import {Component, computed, inject, OnDestroy, OnInit, signal, viewChildren} from '@angular/core'
import {ReactiveFormsModule} from '@angular/forms'
import {MatCard, MatCardContent} from '@angular/material/card'
import {MatError} from '@angular/material/form-field'
import {MatIcon} from '@angular/material/icon'
import {KycService} from '../../../services/kyc.service'
import {ITaxationModel, TaxationCountryComponent} from './country/taxation-country.component'

@Component({
  selector: 'spb-tax-residency',
  imports: [
    ReactiveFormsModule,
    MatCard,
    MatCardContent,
    MatError,
    MatIcon,
    TaxationCountryComponent
  ],
  templateUrl: './tax-residency.component.html',
  styleUrl: './tax-residency.component.scss'
})
export class TaxResidencyComponent implements OnInit, OnDestroy {

  public kycService = inject(KycService)

  /**
   * Indicates whether the user is a US tax resident.
   */
  public isUSTaxResident = computed(() => {
    return this.countryList().includes('US')
  })

  public needsUsTax = computed(() => {
    return !this.isUSTaxResident() && this.isUsCitizen()
  })

  public isUsCitizen = signal(false)

  public countries = signal<ITaxationModel[]>([])

  public children = viewChildren(TaxationCountryComponent)

  public countryList = computed(() =>
    this.countries().map((country) => country.country()))

  public childrenCount = computed(() => this.children().length)

  public valid = computed(() =>
    this.children().every(c => c.valid()) && !this.needsUsTax())

  public ngOnInit() {
    // Set the values based on stored kyc only once.
    this.isUsCitizen.set(this.kycService.kycModel.isUsCitizen)
    this.countries.set(this.kycService.kycModel.taxCountries.map(c => ({
      country: signal(c.country),
      tin: signal(c.tin!)
    })))
  }

  public ngOnDestroy() {
    // Only set it if valid, in case someone press "back".
    if (this.valid()) {
      this.kycService.kycModel.taxCountries = this.countries().map(c => ({
        country: c.country(),
        tin: c.tin()
      }))
    }
  }

  public addParallell() {
    // Remember replace
    this.countries.update(countries => {
      countries.push({
        country: signal(''),
        tin: signal('')
      })
      return [...countries]
    })
  }

  public removeParallel() {
    // Remember to replace the array
    this.countries.update(countries => {
      countries.pop()
      return [...countries]
    })
  }
}